// Audit log components and service — navigation is registered via status-log/index.ts
import {useContaCommand} from '@/commandbar/commandBar.service'
import {PanelContent} from '@tritt/multipanel'
import {registerRoute} from '@/router'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import ActivityLogView from '@/activity-log/ActivityLogView.vue'

export {fetchAuditLog, fetchEntityAuditTrail, actionLabel, actionColor} from '@/activity-log/activity-log.service'

const {registerNavigationCommand} = useContaCommand()

export const ACTIVITY_LOG: PanelContent = {
    componentName: 'ActivityLogView',
    component: ActivityLogView,
    meta: {requiresOrg: true}
}

registerRoute(ACTIVITY_LOG)
const title = 'Aktivitetslogg'
const icon = 'i-ph-clipboard-text'
registerNavigationCommand({
    route: ACTIVITY_LOG,
    label: title,
    icon
})
registerNavigationEntry(NavGroup.MISC, {
    title,
    key: 'activity-log',
    icon,
    target: ACTIVITY_LOG,
    sortOrder: 7
})